var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFixed = function SvgFixed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 14"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M11.602 11.4h-9.2a2 2 0 0 1-2-2V5.152a2 2 0 0 1 2-2h9.2a2 2 0 0 1 2 2V9.4a2 2 0 0 1-2 2M2.226 3.976a1 1 0 0 0-1 1v4.6a1 1 0 0 0 1 1h9.546a1 1 0 0 0 1-1v-4.6a1 1 0 0 0-1-1zM9.199 12.499H.952a.55.55 0 1 0 0 1.1h8.247a.55.55 0 0 0 0-1.1M13.048 12.499h-2.199a.55.55 0 1 0 0 1.1h2.199a.55.55 0 0 0 0-1.1M13.047.953H.952a.55.55 0 0 0 0 1.1h12.095a.55.55 0 0 0 0-1.1"
  })));
};
export default SvgFixed;